import { createFileRoute } from "@tanstack/react-router";
import IstoricMasinaGuide from "@/pages/ghiduri/IstoricMasinaGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/cum-verifici-istoricul-masinii/")({
  head: () => routeHead("/ghiduri/cum-verifici-istoricul-masinii/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <IstoricMasinaGuide />
  );
}
